import ChatMessage from "./ChatMessage";
import QuickReplies from "./QuickReplies";
import TypingIndicator from "./TypingIndicator";

export default function ChatBody({
  messages,
  typing,
 handleOptionClick,
  bottomRef,
}) {
  return (
    <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3 scrollbar-thin scrollbar-thumb-violet-500/30 scrollbar-track-transparent">

      {messages.map((message) => (
        <div key={message.id}>
          <ChatMessage message={message} />

          {message.sender === "bot" &&
            message.options &&
            message.options.length > 0 && (
              <QuickReplies
                options={message.options}
                onSelect={handleOptionClick}
              />
            )}
        </div>
      ))}

      {typing && <TypingIndicator />}

      <div ref={bottomRef}></div>

    </div>
  );
}